// A persistent inline notice in AlertCDS's info colours: AlertCDS itself is a toast that hides.
export const noticeStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 16px',
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.paper : palette.info.extraSoft,
  border: ({ palette }) => (palette.mode === 'dark' ? `1px solid ${palette.info.main}` : 'none'),
};

export const noticeIconStyles = {
  flex: 'none',
  marginTop: '2px',
};

export const noticeTextStyles = {
  color: ({ palette }) => (palette.mode === 'dark' ? palette.info.light : palette.info.dark),
};
